module.exports = __WEBPACK_EXTERNAL_MODULE_react__;


//////////////////
// WEBPACK FOOTER
// external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react"}
// module id = react
// module chunks = 0 1 2